import  { Post } from './Post'

export class Search {
   constructor(){       
    this.postFactory = []
    this.postDateFactory = []
  }

  addPost(data){
    let post = new Post(data);
    if(!this.postFactory.find(currPost => {
      return currPost.post_id == post.post_id
    })){
      this.postFactory.push(post);
    }
    if(!this.postDateFactory.find(date => {
      return date === post.post_date;
    })){
      let arrDate = post.post_date;
      this.postDateFactory.push(arrDate);
    }
  }
 

  getPosts(){
    return this.postFactory.sort(function(a,b){
      if(a.created_at > b.created_at){
        return 1;
      }
      return -1;
    });
  }
  getPostsDates(){
    return this.postDateFactory.sort(function(a,b){
      if(a > b){
        return 1;
      }
      return -1;
    });
  }



}
